var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ 'btn-selected': _vm.selected },domProps:{"innerHTML":_vm._s(_vm.$sanitizeHtml(_vm.button.label))},on:{"click":function($event){return _vm.dispatchButtonClick(_vm.button)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }